import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Activity20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.22 4.28998L10.0649 14.0441L12.7921 6.25222C13.0117 5.62482 13.9154 5.58795 14.1854 6.19538L15.9214 10.1015C15.9615 10.1918 16.0511 10.25 16.1499 10.25H20V11.75H16.1499C15.4583 11.75 14.8316 11.3427 14.5507 10.7107L13.583 8.53328L10.7079 16.7477C10.4724 17.4205 9.47957 17.3942 9.28 16.71L6.48079 7.11269L5.43404 10.5146C5.2081 11.2489 4.52968 11.75 3.76143 11.75H0V10.25L3.76143 10.25C3.87118 10.25 3.96809 10.1784 4.00037 10.0735L5.78317 4.27941C5.9969 3.58477 7.0165 3.59227 7.22 4.28998Z'
      fill='currentColor'
    />
  </Svg>
);

Activity20.displayName = 'Activity20';
export default Activity20;
